export const state = {
  tags: [],
  isLoading: false,
  totalRecords: 0,
  tagPerPage: 10000,
  activePage: 1
}
